import Vue from 'vue';
import WesInfoAccordion from '@/components/WesInfoAccordion.vue';
import WesQuestionAccordion from '@/components/WesQuestionAccordion.vue';
import WesQuestionContainer from '@/components/WesQuestionContainer.vue';
import WesQuestionNumber from '@/components/WesQuestionNumber.vue';
import MatrixAnswer from '@/components/MatrixAnswer.vue';
import WesErrorPanel from '@/components/WesErrorPanel.vue';
import WesHelpPanel from '@/components/WesHelpPanel.vue';
import WesAnswerExplaination from '@/components/WesAnswerExplaination.vue';
import WesError from '@/components/WesError.vue';
import WesQuestionPanel from '@/components/WesQuestionPanel.vue';
import NavBarHome from '@/components/NavBarHome.vue';
import NavBarAdmin from '@/components/NavBarAdmin.vue';
import NavBarSurvey from '@/components/NavBarSurvey.vue';
import Footer from '@/components/Footer.vue';
import FooterAdmin from '@/components/FooterAdmin.vue';
import QuestionStatusIcon from '@/components/QuestionStatusIcon.vue';

Vue.component('wes-error', WesError);
Vue.component('err-panel', WesErrorPanel);
Vue.component('help-panel', WesHelpPanel);
Vue.component('wes-info-accordion', WesInfoAccordion);
Vue.component('wes-accordion', WesQuestionAccordion);
Vue.component('wes-disabled-accordion', WesQuestionPanel);
Vue.component('wes-question-container', WesQuestionContainer);
Vue.component('wes-question-number', WesQuestionNumber);
Vue.component('wes-matrix-answer', MatrixAnswer);
Vue.component('wes-answer-explain', WesAnswerExplaination);
Vue.component('NavBarHome', NavBarHome);
Vue.component('NavBarAdmin', NavBarAdmin);
Vue.component('NavBarSurvey', NavBarSurvey);
Vue.component('Footer', Footer);
Vue.component('FooterAdmin', FooterAdmin);
Vue.component('QuestionStatusIcon', QuestionStatusIcon);
